module.exports = __webpack_public_path__ + "585a3b8d4093ef7743820e37c0e019f3.MP3";